// extracted by mini-css-extract-plugin
export var container = "team-module--container--1vfjF";
export var teamContainer = "team-module--teamContainer--3iL6b";
export var title = "team-module--title--u-vDc";
export var profileContainer = "team-module--profileContainer--1TvhG";
export var profile2Container = "team-module--profile2Container--3G7It";
export var name = "team-module--name--2EoTS";
export var role = "team-module--role--1WWkb";
export var socialContainer = "team-module--socialContainer--1BkkH";